import { API_BASE_URL } from "../../constants/index";
import { defaultFetchParam, FetchParam } from "../../Models/FetchParam";
import { buildAPIUrl } from "../../api/apiHelpers";
import HttpClient from "../../api/httpClient";
import { Carrier } from "../../Models/Carrier";
import { StockReleaseByCarrier } from "../../Models/StockReleaseByCarrier";

export class CarriersService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient();
  }

  all(params: FetchParam = defaultFetchParam): Promise<Carrier[]> {
    return this.httpClient.fetch<Carrier[]>(
      buildAPIUrl(`${API_BASE_URL}/registry-service/carriers`, params),
      { method: "GET" }
    );
  }

  /* ---------------------------------------------------------------------------
   * METHOD: get
   * ------------------------------------------------------------------------- */

  /**
   * Retrieves a single Carrier entry by ID.
   *
   * @param {string} code - The unique identifier of the Carrier entry.
   * @returns {Promise<Carrier>} A promise resolving with the requested Carrier.
   */
  get(code: string): Promise<Carrier> {
    return this.httpClient.fetch<Carrier>(
      `${API_BASE_URL}/registry-service/carriers/${code}`,
      { method: "GET" }
    );
  }

  getStockReleases(code: string): Promise<StockReleaseByCarrier[]> {
    return this.httpClient.fetch<StockReleaseByCarrier[]>(
      `${API_BASE_URL}/registry-service/carriers/${code}/stock-releases`,
      { method: "GET" }
    );
  }
}
